import { ILogsSearchCandidateRequestModel, ILogsSearchCandidateResponseModel } from "./_models"
import axios from "axios"
import { CONST_API_PERSONNEL_SAVED_FILTERS_AND_LOGS_SEARCH_CANDIDAT_POST_GET_LOGS_ENDPOINT } from "../../../../../../../endpoints"

export function getLogsSearchCandidate(filters: ILogsSearchCandidateRequestModel) {
     return axios.post<ILogsSearchCandidateResponseModel>(CONST_API_PERSONNEL_SAVED_FILTERS_AND_LOGS_SEARCH_CANDIDAT_POST_GET_LOGS_ENDPOINT, filters)
}
